<template>
  <el-popover placement="bottom" title="添加流程节点" width="420" trigger="click">
    <div class="node-select">
      <el-tooltip content="指定审批人对流程进行审批，支持同意、拒绝等操作，支持多人审批、会签等方式" placement="top" :enterable="false" :open-delay="1000">
        <div @click="addApprovalNode">
          <i class="el-icon-s-check" style="color:#ff943e;"></i>
          <span>审批人</span>
        </div>
      </el-tooltip>
      <el-tooltip content="指定办理人对流程进行办理，与审批人类似但无拒绝功能，适用于只需执行无需审批决策的节点" placement="top" :enterable="false" :open-delay="1000">
        <div @click="addTaskNode">
          <i class="el-icon-s-claim" style="color:#e6b039;"></i>
          <span>办理人</span>
        </div>
      </el-tooltip>
      <el-tooltip content="将流程信息抄送给指定人员，抄送人无需审批，仅作知会" placement="top" :enterable="false" :open-delay="1000">
        <div @click="addCcNode">
          <i class="el-icon-s-promotion" style="color:#3296fa;"></i>
          <span>抄送人</span>
        </div>
      </el-tooltip>
      <el-tooltip content="排他条件分支，根据条件判断有且只有一条路径会被执行" placement="top" :enterable="false" :open-delay="1000">
        <div @click="addConditionsNode">
          <i class="el-icon-share" style="color:#15bc83;"></i>
          <span>条件分支</span>
        </div>
      </el-tooltip>
      <el-tooltip content="多个分支同时执行，所有分支完成后才继续后续流程" placement="top" :enterable="false" :open-delay="1000">
        <div @click="addConcurrentsNode">
          <i class="el-icon-s-operation" style="color:#718dff;"></i>
          <span>并行分支</span>
        </div>
      </el-tooltip>
      <el-tooltip content="包容条件分支，至少有一条满足条件的路径会被执行，可同时执行多条路径" placement="top" :enterable="false" :open-delay="1000">
        <div @click="addInclusivesNode">
          <i class="el-icon-connection" style="color:#325da2;"></i>
          <span>包容分支</span>
        </div>
      </el-tooltip>
      <el-tooltip content="流程在此节点暂停等待，达到设定时间后自动继续执行" placement="top" :enterable="false" :open-delay="1000">
        <div @click="addDelayNode">
          <i class="el-icon-time" style="color:#f25643;"></i>
          <span>延迟等待</span>
        </div>
      </el-tooltip>
      <el-tooltip content="在流程执行到此节点时自动触发外部系统调用或消息推送" placement="top" :enterable="false" :open-delay="1000">
        <div @click="addTriggerNode">
          <i class="el-icon-set-up" style="color:#ff4500;"></i>
          <span>触发器</span>
        </div>
      </el-tooltip>
      <el-tooltip content="调用已定义的子流程，实现流程的复用与模块化管理" placement="top" :enterable="false" :open-delay="1000">
        <div @click="addSubprocessNode">
          <i class="el-icon-money" style="color:#9274e7;"></i>
          <span>子流程</span>
        </div>
      </el-tooltip>
    </div>
    <el-button icon="el-icon-plus" slot="reference" type="primary" size="small" circle></el-button>
  </el-popover>
</template>

<script>
export default {
  name: 'InsertButton',
  inject: ['$workflow'],
  data () {
    return {}
  },
  computed: {
    selectedNode () {
      return this.$workflow.selectedNode
    }
  },
  methods: {
    addApprovalNode () {
      this.$emit('insertNode', 'APPROVAL')
    },
    addTaskNode () {
      this.$emit('insertNode', 'TASK')
    },
    addCcNode () {
      this.$emit('insertNode', 'CC')
    },
    addDelayNode () {
      this.$emit('insertNode', 'DELAY')
    },
    addConditionsNode () {
      this.$emit('insertNode', 'CONDITIONS')
    },
    addConcurrentsNode () {
      this.$emit('insertNode', 'CONCURRENTS')
    },
    addInclusivesNode () {
      this.$emit('insertNode', 'INCLUSIVES')
    },
    addTriggerNode () {
      this.$emit('insertNode', 'TRIGGER')
    },
    addSubprocessNode () {
      this.$emit('insertNode', 'SUBPROCESS')
    }
  }
}
</script>

<style lang="scss" scoped>
.node-select{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  div{
    flex-basis: calc(33.33% - 8px);
    display: inline-block;
    cursor: pointer;
    padding: 10px;
    border: 1px solid #F8F9F9;
    background-color: #F8F9F9;
    border-radius: 10px;
    position: relative;
    span{
      position: absolute;
      left: 56px;
      top: 18px;
    }
    &:hover{
      background-color: #fff;
      box-shadow: 0 0 8px 2px #d6d6d6;
    }
    i{
      font-size: 25px;
      padding: 5px;
      border: 1px solid #dedfdf;
      border-radius: 14px;
    }
  }
}
</style>
